import { Reveal, StaggerGroup, StaggerItem } from "../components/Reveal";
import { FEATURES } from "../data/content";
import { ArrowUpRight } from "lucide-react";

export default function Features() {
  return (
    <section className="py-24 md:py-32" data-testid="features-section">
      <div className="container-x">
        <div className="max-w-3xl mb-14">
          <Reveal>
            <p className="font-heading font-bold uppercase tracking-[0.2em] text-sm text-[#0033A2] mb-4">
              One app · everything
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading font-extrabold tracking-tight text-4xl md:text-6xl leading-[0.95]">
              Everything your community needs, nothing it doesn't.
            </h2>
          </Reveal>
        </div>

        <StaggerGroup className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <StaggerItem
                key={f.title}
                className={`${f.span} group`}
              >
                <div
                  className="h-full bg-brand-light rounded-3xl p-7 md:p-9 border-2 border-transparent transition-all duration-300 hover:border-black hover:bg-white hover:-translate-y-2 hover:shadow-hard-sm cursor-default"
                  data-testid={`feature-card-${i}`}
                >
                  <div className="flex items-start justify-between">
                    <div className="w-14 h-14 rounded-2xl bg-[#0033A2] flex items-center justify-center mb-6">
                      <Icon size={26} className="text-white" strokeWidth={2} />
                    </div>
                    <ArrowUpRight
                      size={22}
                      className="text-black/30 group-hover:text-[#0033A2] transition-colors"
                      strokeWidth={2.5}
                    />
                  </div>
                  <h3 className="font-heading font-bold text-2xl tracking-tight mb-2">
                    {f.title}
                  </h3>
                  <p className="text-black/65 font-medium leading-relaxed">{f.desc}</p>
                </div>
              </StaggerItem>
            );
          })}

          {/* Oversized typographic tension block */}
          <StaggerItem className="md:col-span-4">
            <div className="h-full bg-[#0033A2] text-white rounded-3xl p-7 md:p-9 flex flex-col justify-between border-2 border-black">
              <p className="font-heading font-bold uppercase tracking-widest text-xs text-white/70">
                And so much more
              </p>
              <p className="font-heading font-black text-4xl md:text-5xl leading-[0.9] tracking-tighter mt-8">
                12+ modules, zero spreadsheets.
              </p>
            </div>
          </StaggerItem>
        </StaggerGroup>
      </div>
    </section>
  );
}
